export const pageBackground = '#F5F8FB';
export const white = '#fff';
export const black = '#2A2E40';
export const orange = '#FF6D39';
export const blue = '#11A1FD';
export const violet = '#6B47FB';
export const gray = '#8F93A9';
export const red = '#DE3E5B';
